define('home/templates/relatedDiscussionsModule',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {};

  return "<header class=\"module-header -plain\">\n<div class=\"module-header__title\">\n<h2 class=\"text-gray-darker\">\n"
    + container.escapeExpression(helpers.gettext.call(alias1,"More from %(source)s",{"name":"gettext","hash":{"source":helpers.getPartial.call(alias1,"channelAwareForumLink",(depth0 != null ? depth0.forum : depth0),{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\n</h2>\n</div>\n</header>\n<div data-role=\"discussions\" class=\"module-body\"></div>\n";
},"useData":true})

});
